import {UppyDashboardWrapper} from "../../helpers/media-files/uppy/UppyDashboardWrapper";
import Axios from "axios";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../helpers/loading";
import {getSingleInputByNameV3} from "../../helpers/forms/formInputsHelpers";

function initMediaFilesExamples() {
	// Init avatar file uploader
	// noinspection JSUnusedLocalSymbols
	const avatarUppyWrapperInstance = new UppyDashboardWrapper(
		document.querySelector('.avatar-upload-dashboard'),
		{
			restrictions: {
				maxNumberOfFiles: 1,
				maxTotalFileSize: 1024 * 1024 * 15, // 15 mb, but server allows only up to 2mb, to test validation
				allowedFileTypes: [
					'image/png',
					'image/jpeg',
					'image/gif',
					'image/bmp',
					'image/webp', // Will be rejected by the server
				]
			},
		},
		{
			height: 'auto'
		}
	)

	const publicUppyWrapperInstance = new UppyDashboardWrapper(
		document.querySelector('.public-files-dashboard'),
		{
			restrictions: {
				maxTotalFileSize: 1024 * 1024 * 20, // 20 mb, more than the server allows to test validation
			},
		},
		{
			height: 'auto'
		}
	)

	const publicAppendUppyWrapperInstance = new UppyDashboardWrapper(
		document.querySelector('.public-files-append-dashboard'),
		{
			restrictions: {
				maxTotalFileSize: 1024 * 1024 * 20, // 20 mb, more than the server allows to test validation
			},
		},
		{
			height: 'auto'
		}
	)

	// Init upload avatar button
	const saveAvatarButton = document.querySelector('.save-avatar-button');
	saveAvatarButton.addEventListener('click', () => {
		handleAvatarUpdate(saveAvatarButton.dataset.route)
	})

	// Init download avatar from url button
	const downloadAvatarButton = document.querySelector('.download-avatar-button');
	downloadAvatarButton.addEventListener('click', () => {
		handleAvatarDownload(downloadAvatarButton.dataset.route)
	})

	// Init public files button
	const savePublicFilesButton = document.querySelector('.save-public-files-button');
	savePublicFilesButton.addEventListener('click', () => {
		handlePublicFilesUpdate(savePublicFilesButton.dataset.route)
	})

	// Init public files append button
	const savePublicFilesAppendButton = document.querySelector('.save-public-files-append-button');
	savePublicFilesAppendButton.addEventListener('click', () => {
		handlePublicFilesAppendUpdate(savePublicFilesAppendButton.dataset.route)
	})

	// Init public files append button
	const useExistingFileButton = document.querySelector('.use-existing-file-as-avatar-button');
	useExistingFileButton.addEventListener('click', () => {
		handleUseExistingFile(useExistingFileButton.dataset.route)
	})

	// Methods

	function handleAvatarUpdate(route) {
		avatarUppyWrapperInstance
			.checkAndPromptForOngoingUploads()
			.then(() => {
				loading();

				Axios.post(route, {
					avatar_file: avatarUppyWrapperInstance.getFilesForSubmission(),
				})
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading)
			})
	}

	function handleAvatarDownload(route) {
		loading();

		Axios.post(route, {
			avatar_download_url: getSingleInputByNameV3(document.body, 'avatar_download_url'),
		})
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}

	function handlePublicFilesUpdate(route) {
		publicUppyWrapperInstance.checkAndPromptForOngoingUploads()
			.then(() => {
				loading();

				Axios.post(route, {
					public_files: publicUppyWrapperInstance.getFilesForSubmission(),
				})
					.then(r => {
						// Clear dashboard and add new returned files to it
						const files = r.data.files;

						publicUppyWrapperInstance.clearFiles();
						publicUppyWrapperInstance.addPreExistingFiles(files, true);

						handleAjaxSuccess(r, () => {
							// Do nothing
						});
					})
					.catch(handleAjaxError)
					.finally(stopLoading)
			})
	}

	function handlePublicFilesAppendUpdate(route) {
		publicAppendUppyWrapperInstance
			.checkAndPromptForOngoingUploads()
			.then(() => {
				loading();

				Axios.post(route, {
					public_files: publicAppendUppyWrapperInstance.getFilesForSubmission(),
				})
					.then(handleAjaxSuccess) // Reload page, so public files card also gets updated
					.catch(handleAjaxError)
					.finally(stopLoading)
			})
	}

	function handleUseExistingFile(route) {
		loading();

		Axios.post(route, {
			file_id: document.querySelector('.use-existing-file-select').value,
		})
			.then(handleAjaxSuccess) // Reload page, so public files card also gets updated
			.catch(handleAjaxError)
			.finally(stopLoading)
	}


}

export {initMediaFilesExamples}
